export default __webpack_public_path__ + "static/media/CERT3.e42f4c77.png";